import React from 'react';
import { StyledHeaderDirectory, StyledHeaderItem } from './style';

const HeaderData = ['Concesión', 'C. Autónoma', 'Frecuencia', 'Teléfono'];

const HeaderDirectory = () => (
  <StyledHeaderDirectory>
    {HeaderData.map((item, i) => (
      <StyledHeaderItem key={`header-g-${i + 1}`}>{item}</StyledHeaderItem>
    ))}
    <StyledHeaderItem />
  </StyledHeaderDirectory>
);

export default HeaderDirectory;
